import { ModulePermissionKeys } from "shared/constants/Modules";
import { FC, ReactNode } from "react";
import { Hideable } from "shared/UI/Hideable/Hideable";
import useLocale from "core/hooks/useLocale/useLocale";
interface LocalizedWrapperProps {
  module: ModulePermissionKeys;
  children: ReactNode;
  onHiddenStateChange?: (localeCondition: boolean) => boolean;
}

const LocalizedWrapper: FC<LocalizedWrapperProps> = ({ module, children, onHiddenStateChange }) => {
  const { isLocalePermitted } = useLocale();
  const isModuleHidden = !isLocalePermitted(module);

  const hideChildren = onHiddenStateChange ? onHiddenStateChange(isModuleHidden) : isModuleHidden;

  return <Hideable hidden={hideChildren}>{children}</Hideable>;
};

export default LocalizedWrapper;
